import { render, staticRenderFns } from "./TableColumns.vue?vue&type=template&id=1ba702d6&lang=html"
import script from "./TableColumns.vue?vue&type=script&lang=js"
export * from "./TableColumns.vue?vue&type=script&lang=js"
import style0 from "./TableColumns.vue?vue&type=style&index=0&id=1ba702d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports